import { MfeConfig } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';

/*
  Configure THIS bundle's @carvana/microfrontend instance before loading the nested
  spinner-loader MFE.

  The SAR MFE bundles its own copy of @carvana/microfrontend, so it has its own framework
  instance separate from whatever host embeds it. Under a Webpack host (Carvana.OP.MyCarvana.UI)
  that instance happened to pick up the globals it needs; under a Vite host (the new my-cars
  app) it does not, so the nested MfeLoad('SpinnerLoaderModule') can't resolve React/styled/etc.
  and silently never renders.

  Mirroring the working VIPR (asr-queue-ui) Vite integration: run MfeConfig with the full
  globals set + skipGlobalSSRLegacy on our own instance, and await it (waitForSpinnerMfe)
  before MfeLoad. Host-agnostic — it configures the SAR MFE's own instance either way.
*/

const ENV = process.env.NODE_ENV === 'production' ? 'production' : 'test';

let initPromise: Promise<void> | null = null;

export function waitForSpinnerMfe(): Promise<void> {
  return initPromise ?? Promise.resolve();
}

export function initSpinnerMfe(): Promise<void> {
  if (initPromise) return initPromise;

  initPromise = MfeConfig(
    {
      name: 'sars-spinner',
      debug: ENV !== 'production',
      Render: MfeReact(),
      ENV: ENV as any,
      globals: {
        React: () => import('react'),
        react: () => import('react'),
        ReactDOM: () => import('react-dom'),
        reactDom: () => import('react-dom'),
        'react-dom': () => import('react-dom'),
        // NOTE: intentionally NOT providing react-dom/client or react/jsx-runtime as globals.
        // Unlike the VIPR Vite host, this MFE is a Webpack bundle where those subpaths aren't
        // externalized, so import()-ing them produces webpack chunks that 404 at the CDN
        // (ChunkLoadError). The spinner-loader doesn't require them as host globals.
        styled: () => import('styled-components'),
        'styled-components': () => import('styled-components'),
        PropTypes: () => import('prop-types'),
        propTypes: () => import('prop-types'),
        'prop-types': () => import('prop-types'),
        uuid: () => import('uuid'),
        axios: () => import('axios'),
      },
      skipGlobalSSRLegacy: true,
      files: [],
    } as any,
    { plugins: [] }
  )
    .then(() => undefined)
    .catch((err: unknown) => {
      // Best-effort: don't wedge the flow if config init fails — the subsequent MfeLoad
      // will still attempt (and SpinnerLocation falls back to the tile list on failure).
      initPromise = null;
      // eslint-disable-next-line no-console
      console.error('initSpinnerMfe: MFE framework config failed:', err);
    });

  return initPromise;
}
